module.exports = __webpack_public_path__ + "img/5.0b6cd2da.png";